/**
 * Rugged Ranch smart search helpers.
 * Expands casual / NLP-style queries into terms Shopify search indexes well.
 */
(function () {
  const PHRASE_MAP = [
    [/chicken\s*hous(e|es)?/gi, 'chicken coop'],
    [/hen\s*hous(e|es)?/gi, 'chicken coop'],
    [/hen\s*coop/gi, 'chicken coop'],
    [/dog\s*cage(s)?/gi, 'dog kennel'],
    [/dog\s*pen(s)?/gi, 'dog kennel'],
    [/dog\s*run(s)?/gi, 'dog kennel'],
    [/rabbit\s*cage(s)?/gi, 'rabbit hutch'],
    [/bunny\s*(cage|hutch)/gi, 'rabbit hutch'],
    [/garden\s*wagon/gi, 'garden cart'],
    [/yard\s*cart/gi, 'garden cart'],
    [/live\s*trap/gi, 'humane trap'],
    [/animal\s*trap/gi, 'humane trap'],
    [/pest\s*trap/gi, 'humane trap'],
    [/rawhide\s*bone(s)?/gi, 'rawhide'],
    [/dog\s*bone(s)?/gi, 'rawhide'],
    [/chew\s*bone(s)?/gi, 'rawhide'],
    [/nesting\s*box(es)?/gi, 'nesting box'],
    [/nest\s*box(es)?/gi, 'nesting box']
  ];

  const TOKEN_MAP = {
    mouse: 'mouseinator mouse trap',
    mice: 'mouseinator mouse trap',
    rat: 'ratinator rat trap',
    rats: 'ratinator rat trap',
    squirrel: 'squirrelinator squirrel trap',
    squirrels: 'squirrelinator squirrel trap',
    chipmunk: 'chipmunkinator chipmunk trap',
    chipmunks: 'chipmunkinator chipmunk trap',
    skunk: 'skunkinator skunk trap',
    skunks: 'skunkinator skunk trap',
    coop: 'chicken coop',
    coops: 'chicken coop',
    kennel: 'dog kennel',
    kennels: 'dog kennel',
    hutch: 'rabbit hutch',
    hutches: 'rabbit hutch',
    trap: 'humane trap',
    traps: 'humane trap',
    cage: 'kennel coop hutch',
    cages: 'kennel coop hutch',
    feeder: 'feeder',
    feeders: 'feeder',
    pen: 'wire pen kennel',
    pens: 'wire pen kennel',
    bone: 'rawhide',
    bones: 'rawhide',
    rawhide: 'rawhide'
  };

  const SUGGESTIONS = [
    { label: 'Skunk traps', query: 'skunkinator' },
    { label: 'Mouse traps', query: 'mouseinator' },
    { label: 'Rat traps', query: 'ratinator' },
    { label: 'Squirrel traps', query: 'squirrelinator' },
    { label: 'Chicken coops', query: 'chicken coop' },
    { label: 'Dog kennels', query: 'dog kennel' },
    { label: 'Rawhide bones', query: 'rawhide' },
    { label: 'Nesting boxes', query: 'nesting box' },
    { label: 'Garden carts', query: 'garden cart' },
    { label: 'Rabbit hutches', query: 'rabbit hutch' }
  ];

  function expandQuery(raw) {
    if (!raw || typeof raw !== 'string') return '';

    let q = raw.trim().replace(/\s+/g, ' ');
    if (!q) return '';

    PHRASE_MAP.forEach(([pattern, replacement]) => {
      q = q.replace(pattern, replacement);
    });

    const tokens = q.toLowerCase().split(/[^a-z0-9+]+/).filter(Boolean);
    const extras = [];

    tokens.forEach((token) => {
      if (TOKEN_MAP[token]) extras.push(TOKEN_MAP[token]);
    });

    if (!extras.length) return q;

    // Keep original wording + mapped product language for broader matching
    const merged = `${q} ${extras.join(' ')}`
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter((word, index, arr) => arr.indexOf(word) === index)
      .join(' ');

    return merged;
  }

  function relatedSuggestions(raw) {
    const q = (raw || '').toLowerCase();
    if (!q) return SUGGESTIONS.slice(0, 6);

    const scored = SUGGESTIONS.map((item) => {
      const hay = `${item.label} ${item.query}`.toLowerCase();
      let score = 0;
      q.split(/\s+/).forEach((part) => {
        if (part.length > 2 && hay.includes(part)) score += 2;
      });
      if (hay.includes(q)) score += 3;
      return { ...item, score };
    });

    const matched = scored.filter((item) => item.score > 0).sort((a, b) => b.score - a.score);
    return (matched.length ? matched : SUGGESTIONS).slice(0, 6);
  }

  function rewriteSearchForms() {
    document.querySelectorAll('form[action*="/search"]').forEach((form) => {
      if (form.dataset.rrSmartSearch === 'true') return;
      form.dataset.rrSmartSearch = 'true';

      form.addEventListener('submit', () => {
        const input = form.querySelector('input[type="search"], input[name="q"]');
        if (!input) return;

        const original = input.value.trim();
        if (!original) return;

        const expanded = expandQuery(original);
        if (expanded) input.value = expanded;
      });
    });
  }

  function enhanceEmptyState() {
    const empty = document.querySelector('[data-rr-search-empty]');
    if (!empty) return;

    const terms = empty.getAttribute('data-terms') || '';
    const list = empty.querySelector('[data-rr-search-suggestions]');
    if (!list) return;

    relatedSuggestions(terms).forEach((item) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'btn-small color-accent-to-base';
      a.href = `/search?q=${encodeURIComponent(item.query)}&options%5Bprefix%5D=last&type=product`;
      a.textContent = item.label;
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  window.RRSmartSearch = {
    expandQuery,
    relatedSuggestions,
    suggestions: SUGGESTIONS
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      rewriteSearchForms();
      enhanceEmptyState();
    });
  } else {
    rewriteSearchForms();
    enhanceEmptyState();
  }
})();
